/** D1 落雨(方案 G4 标杆):weather 组;斜雨丝 + 落地涟漪;三段包络。 */
import { Graphics } from 'pixi.js';
import { BaseEffect, EffectGroup } from './base';
import { weatherPool } from '../engine/ParticlePool';
import { sky } from '../engine/SkyRenderer';
import { world as wind } from '../engine/Ticker';
import { scene } from '../engine/Scene';
import { TEX } from '../engine/Tex';
import { P } from '../engine/Palette';
import { LW } from '../engine/Stage';
import { rand } from '../engine/util';
import { sfx } from '../engine/Sfx';

export class RainEffect extends BaseEffect {
  id = 'rain';
  exclusiveGroup: EffectGroup = 'weather';
  private acc = 0;
  private ripples: { g: Graphics; age: number }[] = [];
  private xMin = 0; private xMax = 1;   // sky_split 用于左半裁剪
  private popped = false;

  constructor() { super(); this.layerName = 'weatherFX'; }

  onStart(meta?: any) {
    if (meta?.xRange) { this.xMin = meta.xRange[0]; this.xMax = meta.xRange[1]; }
    sky.pushWeather('rain', 8);
    sfx.loop('rain', { fadeIn: 3 });
  }

  onUpdate(dt: number) {
    const density = (120 + 180 * this.k) * this.env(4);
    this.acc += density * dt;
    while (this.acc >= 1) { this.acc -= 1; this.spawn(); }
    if (this.t > this.dur && !this.popped) { this.popped = true; sky.popWeather('rain', 10); sfx.stop('rain', 6); }
    for (let i = this.ripples.length - 1; i >= 0; i--) {
      const r = this.ripples[i]; r.age += dt; const p = r.age / 0.5;
      if (p >= 1) { r.g.destroy(); this.ripples.splice(i, 1); continue; }
      r.g.clear();
      r.g.ellipse(0, 0, 8 + p * 14, (8 + p * 14) * 0.32).stroke({ width: 1.5, color: P.rain, alpha: (1 - p) * 0.6 });
    }
  }

  private spawn() {
    const x = rand(LW * this.xMin - 60, LW * this.xMax + 60);
    weatherPool?.spawn({
      x, y: -30, vx: -90 + wind.wind.x, vy: 620, life: 2.4,
      scaleX: 0.3, scaleY: 0.24, tint: P.rain, alpha: 0.5, texture: TEX.streak(), fade: 'none',
      onUpdate: (p) => {
        if (!p.hit && p.y > scene.island.surfaceYAt(p.x)) {
          p.hit = true; p.life = 0;
          if (Math.random() < 0.3) this.ripple(p.x, scene.island.surfaceYAt(p.x));
        }
      },
    });
  }

  private ripple(x: number, y: number) {
    if (this.ripples.length > 30) return;
    const g = new Graphics(); g.position.set(x, y); this.g.addChild(g);
    this.ripples.push({ g, age: 0 });
  }

  onResolve() { if (!this.popped) { this.popped = true; sky.popWeather('rain', 6); sfx.stop('rain', 4); } }
  onDestroy() { if (sky.weather === 'rain') sky.popWeather('rain', 4); }
}
